/**
 * https://github.com/discord/embedded-app-sdk/blob/main/docs/in-app-purchases.md
 *
 * Created by razial on 29.08.2024.
 */

const DiscordPayments = function () {
    Payments.call(this, connector.DISCORD, {
        sdk: SdkManager.SDK_DISCORD
    });
};

DiscordPayments.prototype = Object.create(Payments.prototype);
DiscordPayments.prototype.constructor = DiscordPayments;

DiscordPayments.prototype.canDeliverLate = function () {
    return true;
};

DiscordPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.DISCORD);
};

DiscordPayments.prototype.getProductId = function (product) {
    return product.id.discord;
};

DiscordPayments.prototype._loadProducts = function (callback) {
    discordSdk.commands.getSkus().then((data) => {
        console.log("discord products loaded", data);

        const skus = data && data.skus || [];
        let currency;

        const loadedIds = skus.map((product) => product.id);

        skus.forEach((product) => {
            const ourProduct = this.getProduct(product.id);
            if (ourProduct && product.price) {
                currency = currency || product.price.currency && product.price.currency.toUpperCase();

                const textPrice = DiscordPriceUtils.formatPrice(product.price, "en-US");

                ourProduct.textPrice = textPrice;
                ourProduct.price = parseFloat(textPrice.replace(/[^0-9.-]/g, ""));
                ourProduct.currency = product.price.currency && product.price.currency.toUpperCase();
            }
        });

        this.currency = currency || this.currency;

        callback(connector.CODE_SUCCEED, loadedIds);
    }).catch((e) => {
        console.log("discord load products error", e);

        this.bus.trigger("error:details:discord:loadProducts", e);

        callback(connector.CODE_FAILED);
    });
};

DiscordPayments.prototype.purchase = function (product, callback) {
    let discordPurchase;

    const onSuccess = connector.utils.wait(2, () => {
        console.log("success purchase", discordPurchase);

        const purchase = this.createPurchase(discordPurchase.id, product);

        callback(connector.CODE_SUCCEED, purchase);
    });

    const player = new ConnectorActionPlayer([
        function (f) {
            discordSdk.unsubscribe("ENTITLEMENT_CREATE").then(f)
                .catch((e) => {
                    console.log("discord purchase unsubscribe error", e);

                    this.bus.trigger("error:details:discord:purchase", e);

                    callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: e && e.code, message: e && e.message });
                });
        }.bind(this),

        function (f) {
            discordSdk.subscribe("ENTITLEMENT_CREATE", () => {
                onSuccess();
            }).then(f).catch((e) => {
                console.log("discord purchase subscribe error", e);

                this.bus.trigger("error:details:discord:purchase", e);

                callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: e && e.code, message: e && e.message });
            });
        }.bind(this),

        function (f) {
            discordSdk.commands.startPurchase({
                sku_id: product.productId
            }).then((entitlements) => {
                console.log("discord purchase started", entitlements);

                discordPurchase = entitlements && entitlements[0];
                if (!discordPurchase) {
                    this.bus.trigger("stream:error", `Discord purchase is undefined productId: ${product.productId}`);

                    callback(ERRORS.PURCHASE.UNKNOWN);
                    return;
                }

                f();
            }).catch((e) => {
                console.log("discord purchase error", e);

                this.bus.trigger("error:details:discord:purchase", e);

                let code = ERRORS.PURCHASE.UNKNOWN;
                if (e && e.code === 5008 && e.message === "Purchase was canceled by the user.") {
                    code = ERRORS.PURCHASE.CANCEL;
                }

                this.bus.trigger("error:details:instant:purchase", e);

                callback(code, undefined, { error: e && e.code, message: e && e.message });
            });
        }.bind(this)
    ]);

    player.play(onSuccess);
};

DiscordPayments.prototype.validate = function (purchase, callback) {
    const userId = connector.platform.getUserID();
    const paymentId = purchase.paymentId;

    ConnectorRestClient.get(`/discordpayments/validate/${userId}/${paymentId}`, {}, (response) => {
        console.log("discord validate result", response);

        if (response === "ok") {
            callback(connector.CODE_SUCCEED, purchase);
        } else {
            callback(connector.CODE_FAILED);
        }
    }, (error) => {
        console.log("discord validate error", error);
        callback(connector.CODE_SUCCEED, purchase);
    });
};

DiscordPayments.prototype.consume = function (purchase, callback) {
    const userId = connector.platform.getUserID();
    const paymentId = purchase.paymentId;

    ConnectorRestClient.get(`/discordpayments/consume/${userId}/${paymentId}`, {}, (response) => {
        console.log("discord consume result", response);

        if (response === "ok") {
            callback(connector.CODE_SUCCEED);
        } else {
            callback(ERRORS.CONSUME.UNKNOWN);
        }
    }, (error) => {
        console.log("discord consume error", error);
        callback(ERRORS.CONSUME.UNKNOWN);
    });
};

DiscordPayments.prototype.restore = function (callback) {
    const userId = connector.platform.getUserID();

    ConnectorRestClient.get(`/discordpayments/restore/${userId}`, {}, (discordPurchase) => {
        console.log("discord restore purchase", discordPurchase);

        if (!discordPurchase) {
            callback(connector.CODE_FAILED);
            return;
        }

        const product = this.getProduct(discordPurchase.sku_id);
        const purchase = this.createPurchase(discordPurchase.id, product);

        callback(connector.CODE_SUCCEED, purchase);
    }, (error) => {
        console.log("discord restore error", error);

        callback(connector.CODE_FAILED);
    });
};